import { Dispatch } from 'react';
import {
    fetchEnrollmentSnapshot,
    setCancelEnrollment,
    setMemberEnrollmentResend,
    setReinstateEnrollmentStatus,
    setUpdateEnrollmentStatus,
} from '../../../../actions/memberPortal/enrollmentsActionCreators';
import { ENROLLMENT_STATUSES } from '../../../../constants/individualPortal/dashboard/dashboardModelTypes';
import { useAppDispatch } from '../../../../hooks';
import { endpoints } from '../../utils';
import {
    IGetEnrollmentSnapshotRequest,
    IMemberResendRequest,
    IOverrideEnrollmentStatusRequest,
    IPremiumHistoryEnrollmentRequest,
    IReinstateEnrollmentRequest,
} from '../common/types';

interface IAPIResponse {
    isSuccess?: boolean;
    isError?: boolean;
}

const useEnrollmentModalAPI = () => {
    const dispatch: Dispatch<any> = useAppDispatch();

    const getEnrollmentSnapshot = async (payload: IGetEnrollmentSnapshotRequest) => {
        return await fetchEnrollmentSnapshot(dispatch, payload);
    };

    const setEnrollmentResend = async (payload: IMemberResendRequest): Promise<IAPIResponse> => {
        const result = await setMemberEnrollmentResend(dispatch, payload);
        return result?.status ? { isSuccess: true } : { isError: true };
    };

    const setReinstateStatus = async (payload: IReinstateEnrollmentRequest): Promise<IAPIResponse> => {
        const result = await setReinstateEnrollmentStatus(dispatch, payload);
        return result?.status ? { isSuccess: true } : { isError: true };
    };

    const setEnrollmentStatus = async (
        payload: IOverrideEnrollmentStatusRequest,
        status: string,
    ): Promise<IAPIResponse> => {
        let url = endpoints.MEMBER_ENROLLMENT_LIST_ENROLLMENT_UPDATE_STATUS;
        let postData = {};

        if (status === ENROLLMENT_STATUSES.PEND) {
            url = endpoints.MEMBER_ENROLLMENT_LIST_ENVIRONMENT_CANCEL_PREMIUM_HISTORY;
            postData = { householdCaseId: payload.houseHoldId, coverageYear: payload.coverageYear };
        } else {
            postData = {
                enrollmentId: payload.enrollmentId,
                caseNumber: payload.caseNumber,
                familyMembers: payload.familyMembers,
                overrideCommentText: payload.overrideCommentText,
                houseHoldId: payload.houseHoldId,
            };
        }
        const result = await setUpdateEnrollmentStatus(url, dispatch, postData);

        return result?.status ? { isSuccess: true } : { isError: true };
    };

    const setCancelActiveEnrollment = async (payload: IPremiumHistoryEnrollmentRequest): Promise<IAPIResponse> => {
        const result = await setCancelEnrollment(dispatch, payload);
        return result?.status ? { isSuccess: true } : { isError: true };
    };

    return {
        getEnrollmentSnapshot,
        setEnrollmentResend,
        setReinstateStatus,
        setEnrollmentStatus,
        setCancelActiveEnrollment,
    };
};

export default useEnrollmentModalAPI;
